<template>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        filename="startup.pdf"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        :paginate-elements-by-height="1400"
        :html-to-pdf-options="{
            margin: 5,
            html2canvas: {
                useCORS: true,
                scrollY: 0,
            },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy']},
            image: {
                type: 'jpeg',
                quality: 0.5
            }
        }"
        @beforeDownload="download"
        ref="html2Pdf"
    >

        <section slot="pdf-content" class="pdf-version">

            <div v-for="(startup, index) in startups" :key="index">

                <header class="header">
                    <div class="header__navigation">
                        <div href="/" class="logo" title="Switch Pitch"></div>
                    </div>
                </header>

                <main class="main" v-if="typeof startup.commonData !== 'undefined'">
                    <aside class="aside aside--details">
                        <div class="aside__inner">
                            <div class="image-block image-block--lg mt-0">
                                <img :src="getLogoUrl($api.defaults.baseURL + '/img/startup-logos/' + startup.commonData.logo_url)" alt="img"/>
                            </div>
                            <h2 class="heading2">{{startup.commonData.name}}</h2>

                            <div v-if="false" class="type-label">Buzzing</div>

                            <h4 class="heading4 heading4--tertiary">
                                Overview
                                <a v-if="false" class="heading-edit"></a>
                            </h4>

                            <ul class="overview-list">
                                <li v-if="startup.commonData.url_domain.length">
                                    <a :href="'http://' + startup.commonData.url_domain" target="_blank">
                                        <span class="d-flex align-items-center">
                                            <span class="overview-list__icon icon-globe"></span>
                                            {{ startup.commonData.url_domain }}
                                        </span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.total_raised > 0">
                                    <span class="d-flex align-items-center"><span class="overview-list__icon icon-funding"></span>$ {{stringHelper.formatNumber(startup.commonData.total_raised)}}</span>
                                </li>
                                <li v-if="startup.commonData.revenue_range"><span class="overview-list__icon icon-income"></span> {{ startup.commonData.revenue_range }} Annual Income</li>
                                <li v-if="startup.commonData.employees">
                                    <span class="d-flex align-items-center">
                                        <span class="overview-list__icon icon-users"></span>
                                        {{ startup.commonData.employees }} Employees
                                    </span>
                                </li>
                                <li>
                                    <span class="d-flex align-items-center">
                                        <span class="overview-list__icon icon-pin"></span>
                                        {{ getLocation(startup.commonData) }}
                                    </span>
                                </li>
                                <li><span class="overview-list__icon icon-sturtups"></span> {{ startup.commonData.stage }}</li>
                                <li v-if="startup.commonData.founded"><span class="overview-list__icon icon-founded"></span> Founded {{ startup.commonData.founded }}</li>
                            </ul>

                            <ul class="social-list">
                                <li v-if="startup.commonData.linkedin_url">
                                    <a :href="startup.commonData.linkedin_url">
                                        <span class="social-list__icon social-list__icon-ln"></span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.twitter_url">
                                    <a :href="startup.commonData.twitter_url">
                                        <span class="social-list__icon social-list__icon-twitter"></span>
                                    </a>
                                </li>
                                <li v-if="startup.commonData.facebook_url">
                                    <a :href="startup.commonData.facebook_url">
                                        <span class="social-list__icon social-list__icon-facebook"></span>
                                    </a>
                                </li>
                            </ul>

                            <template v-if="startup.commonData.categories.length">
                                <h4 class="heading4 heading4--tertiary">
                                    Categories
                                    <a v-if="false" class="heading-edit"></a>
                                </h4>

                                <div class="tags-list tags-list--light">
                                    <span v-for="category in startup.commonData.categories" :key="category.id" class="tags-list__tag">{{ category.name }}</span>
                                </div>
                            </template>

                            <p v-if="startup.commonData.crunch_status">
                                Data provided by Crunchbase <br>
                                Updated {{ dateHelper.decodeDate(startup.commonData.last_crunchbase_sync_date) }}
                            </p>
                            <p v-else>
                                Data provided by SwitchPitch
                            </p>
                            <!--                    <a class="link" href="#">More</a>-->
                            <template v-if="false && startup.commonData.website_keywords.length">
                                <div class="accordion mt-4">
                                    <header class="accordion__header" v-b-toggle.accordion-1 >
                                        <h4 class="accordion__title heading4 heading4--tertiary mb-0">Website Keywords</h4>
                                    </header>
                                    <b-collapse visible id="accordion-1" accordion="my-accordion" >
                                        <div class="tags-list tags-list--light">
                                            <span v-for="keyword in startup.commonData.website_keywords" :key="keyword">
                                                {{ keyword }},
                                            </span>
                                        </div>
                                    </b-collapse>
                                </div>
                            </template>
                        </div>
                    </aside>

                    <div class="content details-field">
                        <h4 class="heading4">Description</h4>

                        <p v-if="startup.commonData.description && startup.commonData.description.length">{{startup.commonData.description}}</p>
                        <p v-else>{{startup.commonData.short_description}}</p>

                        <div v-for="(section, sectionId) in startup.customFields" :key="sectionId">
                            <header class="details-field__header">
                                <h4 class="heading4">{{section.name}}</h4>

                                <div class="section-users ml-auto">
                                    <div class="section-users__images">
                                        <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(section.permissions)" :key="index" class="section-users__images__item">
                                            <img :src="avatar" style="width: 30px;" alt=""/>
                                        </div>
                                    </div>

                                    <p>
                                        <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(section.permissions)" :key="index">
                                            {{item}}
                                        </a>
                                    </p>
                                </div>

                            </header>


                            <table class="details-table">
                                <tr v-for="field in section.fields" :key="field.id">
                                    <td colspan="2" v-if="field.type == 'static_text'" class="pr-3">
                                        {{field.name}}
                                    </td>
                                    <td v-else>
                                        {{field.name}}
                                    </td>

                                    <td v-if="field.type != 'static_text'">
                                        <custom-field
                                            :disabled="true"
                                            :field="field"
                                            :value="startup.customData[field.id]"
                                            :editable="false"
                                            :forPDF="true"
                                        >
                                        </custom-field>
                                    </td>
                                </tr>

                                <tr v-if="section.is_default">
                                    <td>
                                        Tags
                                    </td>
                                    <td>
                                        <div class="tags-list tags-list--light">
                                    <span v-for="tag in startup.tags" :key="tag.id" class="tags-list__tag">
                                        {{ tag.name }}
                                    </span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div v-if="typeof startup.answers !== 'undefined'">
                            <header class="details-field__header">
                                <h4 class="heading4">Submitted answers</h4>
                            </header>

                            <div class="details-table mt-2">
                                <div v-for="(answer, index) in startup.answers.before_break" :key="index">
                                    <div class="html2pdf__page-break" v-if="answer.break"></div>
                                    <div>
                                        <strong>{{answer.field.name}}</strong>
                                    </div>

                                    <div>
                                        <custom-field
                                            :disabled="true"
                                            :field="answer.field"
                                            :value="answer.value"
                                            :editable="false"
                                            :forPDF="true"
                                        >
                                        </custom-field>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <div class="details-table mt-2" style="padding: 15px" v-if="typeof startup.answers !== 'undefined' && startup.answers.after_break.length">
                    <div v-for="(answer, index) in startup.answers.after_break" :key="index">
                        <div>
                            <strong>{{answer.field.name}}</strong>
                        </div>

                        <div>
                            <custom-field
                                :disabled="true"
                                :field="answer.field"
                                :value="answer.value"
                                :editable="false"
                                :forPDF="true"
                            >
                            </custom-field>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </section>
    </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf"
import customField from "@/components/customFields/CustomField"
import files from "@/services/files.service"

export default {
    components: {
        customField,
        VueHtml2pdf,
    },

    props: {
        startups: Array
    },

    methods: {
        generatePdf() {
            this.$refs.html2Pdf.generatePdf()
        },

        getLogoUrl(logoUrl) {
            if (logoUrl) {
                return logoUrl
            }
            else {
                return require('@/images/' + this.defaults.startupLogo)
            }
        },

        getLocation(commonData) {
            let str = []

            if (commonData.city) {
                str.push(commonData.city)
            }

            if (commonData.state) {
                str.push(commonData.state)
            }

            if (commonData.country) {
                str.push(commonData.country)
            }

            if (commonData.continent) {
                str.push(commonData.continent)
            }

            return str.join(', ')
        },

        download: async function({html2pdf, options, pdfContent}) {
            let html2PdfSetup = html2pdf().set(options).from(pdfContent)
            let pdfBlobUrl = await html2PdfSetup.output('bloburl')
            var res = await fetch(pdfBlobUrl);
            var pdfFile = await res.blob();

            let data = window.URL.createObjectURL(pdfFile)

            let fileNames = []
            this.startups.forEach(startup => {
                if (startup.commonData.logo_url) {
                    fileNames.push(startup.commonData.logo_url)
                }
            })

            files.deleteTempLogoFiles(fileNames)

            window.open(data, "_blank");
        },
    }
}
</script>

<style scoped>

</style>